import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Tag,
  Space
} from "antd";


const EventsGeneralInfo = ({ data, status }) => {

  const { TextArea } = Input;
  const [formLayout, setFormLayout] = useState('horizontal');

  const formItemLayout =
    formLayout === 'horizontal'
      ? {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 14,
        },
      }
      : null;

  const formName = "GeneralInfoForm";
  const [form] = Form.useForm();
  useEffect(() => {
    loadGeneralInfo()
  }, [data])

  const loadGeneralInfo = () => {
    form.setFieldsValue({
      name: data.name,
      description: data.description,
      theme: data.theme,
      eventType: data.type,
      eventDate: data.eventDate,
      totalParticipants: data.totalParticipants
    })

  }

  return (
    <>
      <Form
        {...formItemLayout}
        name={formName}
        form={form}
        layout="horizontal"
        initialValues={{
          layout: formLayout,
        }}
        disabled
      >
        <Form.Item
          name="name"
          label="Event Name"
        >
          <Input name="name" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Event Description"
        >
          <TextArea name="description" rows={6} />
        </Form.Item>
        <Form.Item
          name="theme"
          label="Event Group/Theme"
        >
          <Input name="theme" />
        </Form.Item>
        <Form.Item
          name="targetParticipants"
          label="Target Participants"
        >
          <Space size={[8, 16]} wrap>
            {data.targetParticipants?.map((x) => (
              <Tag key={x.key}>{x.value}</Tag>
            ))}
          </Space>

          {/* <Input name="target" /> */}
        </Form.Item>
        <Form.Item
          name="eventType"
          label="Event Type"
        >
          <Input name="eventType" />
        </Form.Item>
        <Form.Item
          name="eventDate"
          label="Event Date"
        >
          <Input name="eventDate" />

        </Form.Item>
        {(status === "Approved" || status === "Concluded" || status === "Archived") && (
          <Form.Item
            name="totalParticipants"
            label="Number of Participants"
          >
            <Input name="totalParticipants" />

          </Form.Item>
        )}
       
      </Form>
    </>
  )
}

export default EventsGeneralInfo